module.exports = __webpack_public_path__ + "img/wm_img_no_login.1641520899224.png";